import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { HelpSection } from "./types";

interface HelpTocProps {
	sections: HelpSection[];
	activeSection: string;
	onSelect: (sectionId: string) => void;
}

export const HelpToc = ({ sections, activeSection, onSelect }: HelpTocProps) => {
	const { t } = useTranslation();

	return (
		<aside className="hidden lg:block">
			<div className="sticky top-6">
				<p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-3 pl-3">
					{t("help.sidebar.title")}
				</p>
				<nav className="flex flex-col border-l border-border">
					{sections.map((section) => {
						const isActive = section.id === activeSection;
						return (
							<button
								key={section.id}
								type="button"
								onClick={() => onSelect(section.id)}
								className={cn(
									"text-left text-sm py-1.5 pl-3 -ml-px border-l transition-colors",
									isActive
										? "border-primary text-foreground font-medium"
										: "border-transparent text-muted-foreground hover:text-foreground hover:border-border",
								)}
							>
								{t(section.titleKey)}
							</button>
						);
					})}
				</nav>
			</div>
		</aside>
	);
};

interface HelpTocMobileProps extends HelpTocProps {}

export const HelpTocMobile = ({ sections, activeSection, onSelect }: HelpTocMobileProps) => {
	const { t } = useTranslation();
	return (
		<div className="lg:hidden mb-6">
			<Select value={activeSection} onValueChange={onSelect}>
				<SelectTrigger>
					<SelectValue placeholder={t("help.sidebar.mobileSelectLabel")} />
				</SelectTrigger>
				<SelectContent>
					{sections.map((section) => (
						<SelectItem key={section.id} value={section.id}>
							{t(section.titleKey)}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
